import { useSyncExternalStore } from 'react'

/** Subscribe to a CSS media query (false where matchMedia is unavailable). */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (cb) => {
      const m = window.matchMedia?.(query)
      if (!m) return () => {}
      m.addEventListener?.('change', cb)
      return () => m.removeEventListener?.('change', cb)
    },
    () => !!window.matchMedia?.(query).matches,
    () => false,
  )
}

/** The help panel docks beside the content (non-modal) from this width; below it is a modal drawer. */
export const HELP_DOCK_QUERY = '(min-width: 1280px)'
export const HELP_PANEL_WIDTH = 400
